/**
 * [정책]: 모두의차고 상세 설치율 A/B 테스트입니다. A는 기존 화면(default), B는 잠금 화면(lock)입니다.
 * 배정은 쿠키로 하고, 인앱 웹뷰와 크롤러는 배정하지 않고 A로 고정합니다. (WEB-5768)
 */

/** [정책]: 킬 스위치입니다. false로 바꾸면 쿠키를 쓰지 않고 전원 A로 그립니다(노출 이벤트 from=disabled). */
export const LOCK_AB_EXPERIMENT_ENABLED = true

export const LOCK_AB_ALLOCATION = 100

/** [주의]: 쿠키·af_sub1·노출 이벤트 status에 같이 쓰는 값입니다. 바꾸면 기존 배정 쿠키와 이벤트 집계가 어긋납니다. */
export const LOCK_AB_VARIANT = {
  DEFAULT: 'default',
  LOCK: 'lock',
} as const

export type TLockAbVariant =
  (typeof LOCK_AB_VARIANT)[keyof typeof LOCK_AB_VARIANT]

export type TLockAbFrom = 'new' | 'returning' | 'disabled' | 'override'

/** [주의]: HttpOnly를 붙이지 않습니다. 붙이면 클라이언트가 쿠키를 다시 쓰지 못해 만료를 연장할 수 없습니다. */
export const LOCK_AB_COOKIE_NAME = 'mc_ab_modoocar_lock_v1'
/** [주의]: 상세와 랭킹이 모두 이 경로 아래에 있어야 같은 쿠키를 읽습니다. */
export const LOCK_AB_COOKIE_PATH = '/v2/modoocar'
/** [라이브러리]: 만료는 60일이고, 방문할 때마다 다시 써서 Safari ITP의 7일 제한을 피합니다. */
export const LOCK_AB_COOKIE_MAX_AGE_SEC = 5_184_000

/** [정책]: dev·stage에서만 쓰는 강제 분기 쿼리입니다(`?ab_variant=lock|default`). prod에서는 무시합니다. */
export const LOCK_AB_OVERRIDE_PARAM = 'ab_variant'

export const LOCK_AB_EXPOSURE_CODE = 'ab_exposure'
export const LOCK_AB_EXPOSURE_LABEL = 'modoocar_detail_lock'

/** [주의]: 실험과 관계없이 항상 붙입니다. 잠금 지면 code는 이벤트 code와 같은 값이어야 앱 설치를 이벤트와 연결할 수 있습니다. */
export const LOCK_AB_AF_SUB2 = {
  LOCK_MILEAGE: 'lock_mileage',
  LOCK_TREND: 'lock_trend',
  LOCK_REVIEW: 'lock_review',
  REVIEW_MORE: 'review_more',
  BOTTOM_CTA: 'bottom_cta',
  SIDE_CTA: 'side_cta',
  PROMOTION_BANNER: 'promotion_banner',
  RANK_MORE: 'rank_more',
  RANK_BOTTOM_CTA: 'rank_bottom_cta',
} as const

export type TLockAbAfSub2 =
  (typeof LOCK_AB_AF_SUB2)[keyof typeof LOCK_AB_AF_SUB2]

/** [주의]: OneLink 이동이 먼저 일어나면 클릭 이벤트가 유실됩니다. 그래서 전송이 끝나거나 이 시간이 지날 때까지 기다린 뒤 이동합니다. */
export const LOCK_AB_CLICK_TRACK_TIMEOUT_MS = 500
